import { render, staticRenderFns } from "./Endorsement.vue?vue&type=template&id=5f2feebc&scoped=true&"
import script from "./Endorsement.vue?vue&type=script&lang=js&"
export * from "./Endorsement.vue?vue&type=script&lang=js&"
import style0 from "./Endorsement.vue?vue&type=style&index=0&id=5f2feebc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2feebc",
  null
  
)

export default component.exports